




















import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ImageDto, ImageFilterDto} from "@swagger";
import ImagePreview from "@/components/ImagePreview.vue";

@Component({
  components: {ImagePreview}
})
export default class ManuallyExpandableImagePreview extends BasicComponent {

  @Prop(Object) image: ImageDto;
  @Prop(String) filter: ImageFilterDto;
  /**
   * The component allows to toggle the favorite state
   */
  @Prop({
    type: Boolean,
    default: false
  }) readonly favoriteEditable: boolean;
  @Prop({
    type: Boolean,
    default: true
  }) readonly showFavoriteIcon: boolean;
  @Prop(String) readonly smallHeight: string;
  @Prop(String) readonly smallWidth: string;

  imageLoaded: boolean = false;

  openPreview() {
    const ref: ImagePreview = this.$refs.imagePreview as ImagePreview;
    if (!ref) return;
    ref.openDialog();
  }

  onSelect() {
    this.$emit("select");
  }

}

